export const SITE_REPORT_ID = 'site';
